/**
*
* Disclaimer: Source code mentioned below is(are) Intellectual Property of
* Crayon Data Holdings Limited (including its subsidiaries and affiliates).
* Crayon Data Holdings Limited reserves right to own and control it the way
* it may deem fit. You must refrain from use, access, read, modify, add or
* delete, sell or use in any other package or programme pertaining to such
* source code without explicit prior written approval of
* Crayon Data Holding Limited. Breach of the same shall attract penalty as
* applicable.
*
*/

// Heading Component
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import uiConfig from "../../uiConfig";

const lang = localStorage.getItem("language");

export default class Heading extends PureComponent {
  static get propTypes() {
    return {
      title: PropTypes.string,
      varient: PropTypes.oneOf(["normal", "list"])
    };
  }

  static get defaultProps() {
    return {
      title: "",
      varient: "normal"
    };
  }

  /* Main Render Functions */
  render() {
    const { title, varient } = this.props;

    const cls = {
      "hed-tit": true,
      "hed-tit-ar": lang === "AR" ? true : false,
      "hed-tit-lst": varient === "list"
    };

    return <div className={clsx(cls)} style={uiConfig.config.whitelabel.components.itemsListHeadingColor ? {color:uiConfig.config.whitelabel.components.itemsListHeadingColor}: {}}>{title}</div>;
  }
}
